/* ==========================================================================
   Luxury Testimonial Slider Custom Element
   ========================================================================== */

if (!customElements.get('testimonial-slider')) {
  customElements.define(
    'testimonial-slider',
    class TestimonialSlider extends HTMLElement {
      constructor() {
        super();
        this.slides = [];
        this.dots = [];
        this.currentIndex = 0;
        this.autoplayTimer = null;
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.testimonial-slide'));
        this.dots = Array.from(this.querySelectorAll('.testimonial-slider__dot'));
        this.prevBtn = this.querySelector('[data-action="prev"]');
        this.nextBtn = this.querySelector('[data-action="next"]');

        if (this.slides.length <= 1) return;

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => {
            this.goTo(this.currentIndex - 1);
            this.resetAutoplay();
          });
        }

        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => {
            this.goTo(this.currentIndex + 1);
            this.resetAutoplay();
          });
        }

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.goTo(index);
            this.resetAutoplay();
          });
        });

        // Swipe gesture support
        let startX = 0;
        this.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
        }, { passive: true });

        this.addEventListener('touchend', (e) => {
          const endX = e.changedTouches[0].clientX;
          const diff = startX - endX;
          if (Math.abs(diff) > 40) {
            if (diff > 0) {
              this.goTo(this.currentIndex + 1);
            } else {
              this.goTo(this.currentIndex - 1);
            }
            this.resetAutoplay();
          }
        }, { passive: true });

        // Autoplay
        const autoplay = this.dataset.autoplay === 'true';
        const interval = parseInt(this.dataset.interval, 10) || 6000;

        if (autoplay) {
          this.startAutoplay(interval);
          this.addEventListener('mouseenter', () => this.stopAutoplay());
          this.addEventListener('mouseleave', () => this.startAutoplay(interval));
        }

        // Shopify Theme Editor block select
        document.addEventListener('shopify:block:select', (event) => {
          if (event.target && event.target.classList.contains('testimonial-slide')) {
            const index = this.slides.indexOf(event.target);
            if (index !== -1) {
              this.goTo(index);
              this.stopAutoplay();
            }
          }
        });
      }

      goTo(index) {
        if (!this.slides.length) return;
        const total = this.slides.length;
        this.currentIndex = (index + total) % total;

        this.slides.forEach((slide, idx) => {
          if (idx === this.currentIndex) {
            slide.classList.add('is-active');
          } else {
            slide.classList.remove('is-active');
          }
        });

        this.dots.forEach((dot, idx) => {
          if (idx === this.currentIndex) {
            dot.classList.add('is-active');
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.classList.remove('is-active');
            dot.removeAttribute('aria-current');
          }
        });
      }

      startAutoplay(interval) {
        this.stopAutoplay();
        this.autoplayTimer = setInterval(() => {
          this.goTo(this.currentIndex + 1);
        }, interval);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      resetAutoplay() {
        const autoplay = this.dataset.autoplay === 'true';
        const interval = parseInt(this.dataset.interval, 10) || 6000;
        if (autoplay) {
          this.startAutoplay(interval);
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }
    }
  );
}
